import React from "react";
import { LoadingScreen } from "./view.js";
import { styles } from "./styles.js";

export class Loading extends React.Component {
  render() {
    return <LoadingScreen {...this.props} styles={styles} />;
  }
}
